import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { useState } from "react";

const OrderDashboardFilters = ({ filters, onChange }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (field, value) => {
    const updated = { ...localFilters, [field]: value };
    setLocalFilters(updated);
  };

  const handleApply = () => {
    onChange(localFilters);
  };

  const handleReset = () => {
    const resetFilters = {
      period: "week",
      startDate: null,
      endDate: null,
      reps: [],
      locations: [],
    };
    setLocalFilters(resetFilters);
    onChange(resetFilters);
  };

  return (
    <Stack spacing={2}>
      <Grid
        container
        spacing={2}
      >
        {/* Date Range */}
        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
          <FormControl
            fullWidth
            size="small"
            sx={{ minWidth: "150px" }}
          >
            <InputLabel>Period</InputLabel>
            <Select
              label="Period"
              value={localFilters.period || "week"}
              onChange={(e) => handleChange("period", e.target.value)}
            >
              <MenuItem value="day">Today</MenuItem>
              <MenuItem value="week">This Week</MenuItem>
              <MenuItem value="payPeriod">Pay Period</MenuItem>
              <MenuItem value="month">This Month</MenuItem>
              <MenuItem value="custom">Custom</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* Custom Date Range (if selected) */}
        {localFilters.period === "custom" && (
          <>
            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
              <input
                type="date"
                value={localFilters.startDate || ""}
                onChange={(e) => handleChange("startDate", e.target.value)}
                style={{ width: "100%", minWidth: "150px", padding: "8px" }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
              <input
                type="date"
                value={localFilters.endDate || ""}
                onChange={(e) => handleChange("endDate", e.target.value)}
                style={{ width: "100%", minWidth: "150px", padding: "8px" }}
              />
            </Grid>
          </>
        )}

        {/* Field Rep Filter */}
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <FormControl
            fullWidth
            size="small"
            sx={{ minWidth: "200px" }}
          >
            <InputLabel>Field Reps (optional)</InputLabel>
            <Select
              label="Field Reps (optional)"
              multiple
              value={localFilters.reps || []}
              onChange={(e) => handleChange("reps", e.target.value)}
            >
              <MenuItem value="all">All Reps</MenuItem>
              {/* TODO: Populate from API */}
            </Select>
          </FormControl>
        </Grid>

        {/* Location Filter */}
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <FormControl
            fullWidth
            size="small"
            sx={{ minWidth: "200px" }}
          >
            <InputLabel>Locations (optional)</InputLabel>
            <Select
              label="Locations (optional)"
              multiple
              value={localFilters.locations || []}
              onChange={(e) => handleChange("locations", e.target.value)}
            >
              <MenuItem value="all">All Locations</MenuItem>
              {/* TODO: Populate from API */}
            </Select>
          </FormControl>
        </Grid>

        {/* Action Buttons */}
        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ height: "100%" }}
          >
            <Button
              variant="contained"
              onClick={handleApply}
              fullWidth
            >
              Apply
            </Button>
            <Button
              variant="outlined"
              onClick={handleReset}
              fullWidth
            >
              Reset
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default OrderDashboardFilters;
